<template>
  <div class="notes-section">
    <section v-for="note in notesArray" :key="note.id" class="note-body-wrap">
      <div class="note">
        <div class="notes-header">
          <div class="note-info">
            <span class='note-username'>{{note.user_name}}</span>
            <span class='note-timestamp'> {{prettyDate(note.updated_at)}} </span>
          </div>
        </div>
        <div class='note-content'>
          {{note.text}}
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { helpersMixins } from '@/mixins/helpersMixins'
export default {
  name: 'MessageNotes',
  mixins: [helpersMixins],
  props: ['notes'],
  data () {
    return {
      notesArray: []
    }
  },
  watch: {
    notes: function () {
      this.notesArray = this.notes
    }
  },
  created () {
    this.notesArray = this.notes
  },
  mounted () {
    var vm = this
    this.$root.$on('noteWasAdded', (data) => {
      vm.notesArray.push(data)
    })
  }
}
</script>
<style scoped>
  .notes-section {
    margin-top: 50px;
  }
  .note-info{
    display: inline-block;
  }
  .note {
    border-radius: 0px 10px 0px 10px;
    -moz-border-radius: 0px 10px 0px 10px;
    -webkit-border-radius: 0px 10px 0px 10px;
    border: 0px solid #000000;
    -webkit-box-shadow: -1px 1px 0px 0px rgba(255,198,70,1);
    -moz-box-shadow: -1px 1px 0px 0px rgba(255,198,70,1);
    box-shadow: -1px 1px 0px 0px rgba(255,198,70,1);
  }
  .note-body-wrap {
    margin: 0 15px 0 0px;
    padding: 15px 1px;
  }
  .note-username {
    font-size: 9pt
  }
  .note-timestamp {
    font-size: 8pt
  }
  .note {
    width: 100%;
    line-height: 1.3em;
    word-wrap: break-word;
  }
  .notes-header {
    width: 100%;
    display: block;
    height: 15px;
    padding: 0;
    text-align: right;
   }
   .note-content {
    width: 100%;
    display: block;
    height: 100%;
    padding: 5px;
    text-align: left;
    margin-top: 5px;
   }
  .oi-share {
    -moz-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    filter: FlipH;
    -ms-filter: "FlipH";
  }
  ul {
    list-style: none;
    margin: 0;
    height: 54px;
    float: left;
    position: relative;
    z-index: 101;
    margin-left: 8px;
    padding: 7px 5px 6px 0;
  }
  li {
    display: inline;
  }
  li > a {
    padding: 8px 14px;
  }
  li span {
    font-size: 24px;
    line-height: 41px;
    color: #fff;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }
  .caret::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 1px;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/MessageNotes.vue